import { Routes } from '@angular/router';
import { authGuard } from '@v1/core/guard/auth.guard';
import { RouteAuth } from '@v1/modules/auth/dom/route-auth';
import { AppVersion } from '@v1/modules/auth/dom/app-version';
import { AppDom } from '@v1/modules/auth/dom/app-dom';
import { RouteCore } from '@v1/modules/auth/dom/route-core';

export const routes: Routes = [
  {
    path: AppVersion.v1,
    children: [
      {
        path: AppDom.auth,
        children: [
          {
            path: RouteAuth.sessionClosed,
            redirectTo: '/v1/core/dashboard',
          },
          {
            path: RouteAuth.callback,
            loadComponent: () => import('./v1/features/callback/callback').then((c) => c.Callback),
          },
        ],
      },
      {
        path: AppDom.core,
        // resolve: {
        //   refreshTokenResolve: refreshTokenResolve,
        // },
        children: [
          {
            path: RouteCore.dashboard,
            canActivate: [authGuard],
            loadComponent: () =>
              import('./v1/features/hub-dashboard/hub-dashboard').then((c) => c.HubDashboard),
          },
        ],
      },
    ],
  },
  {
    path: '',
    redirectTo: `${AppVersion.v1}/${AppDom.core}/${RouteCore.dashboard}`,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: `${AppVersion.v1}/${AppDom.core}/${RouteCore.dashboard}`,
  },
];
